// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2DP6K","clinicsSelect":"TableHeading_clinicsSelect__21dWM"};